import { useState, useEffect } from "react";
import { Frame, Input, ValidaUid, Loading } from "../components";
import { ValidaEmail, ValidaRedefinir } from "../components/Validacao";
import { auth } from "../config/firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const Redefinir = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const buscaDados = async () => {
      const uid = await ValidaUid();

      if (uid) navigate("/home");
      else setLoading(false);
    };

    buscaDados();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const HandleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const erroEmail = ValidaEmail(email);

    if (erroEmail) {
      setErro({ email: erroEmail });
      setLoading(false);
    } else {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          setLoading(false);
          alert("Verifique seu email");
        })
        .catch((err) => {
          setLoading(false);
          setErro(ValidaRedefinir(err.code));
        });
    }
  };

  return (
    <>
      {loading && <Loading />}
      <Frame
        body={
          <div className="px-3">
            <form autoComplete="off" onSubmit={HandleSubmit} noValidate>
              <div className="row mt-2">
                <Input
                  id="email"
                  label="Enviaremos um link de redefinição"
                  type="email"
                  className={erro.email && "is-invalid"}
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  erro={erro.email}
                  autoFocus
                />
              </div>
              <div className="row mt-3">
                <button type="submit" className="btn btn-primary ">
                  REDEFINIR
                </button>
              </div>
            </form>
          </div>
        }
        footer={
          <div>
            <hr />
            <div className="mt-1">
              Já possui cadastro?{" "}
              <a href="/login" className="text-dark">
                Faça login
              </a>
            </div>
            <div className="mt-1">
              Não é cadastrado?{" "}
              <a href="cadastro" className="text-dark">
                Cadastre-se aqui
              </a>
            </div>
          </div>
        }
        title="Esqueceu a senha?"
        logo
        copyright
      />
    </>
  );
};

export default Redefinir;
